import { __makeTemplateObject } from "tslib";
import { css, jsx } from '@emotion/react';
import { Text, View, useTheme } from '@ion-ui/core';
export var SimulatorCards = function SimulatorCards(_a) {
  var icon = _a.icon,
      title = _a.title,
      description = _a.description,
      checked = _a.checked,
      callback = _a.callback;
  var theme = useTheme();
  var cardContent = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 5.625rem;\n    border-bottom: 0.063rem solid ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: start;\n    cursor: pointer;\n    margin: 0.6rem 0 0.75rem 0;\n  "], ["\n    height: 5.625rem;\n    border-bottom: 0.063rem solid ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: start;\n    cursor: pointer;\n    margin: 0.6rem 0 0.75rem 0;\n  "])), theme.colors.scales.gray[3]);
  var content = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    p {\n      font-size:0.75rem;\n      margin:0;\n      padding:0;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    width: 100%;\n    p {\n      font-size:0.75rem;\n      margin:0;\n      padding:0;\n    }\n  "])));
  var imageContainer = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 2.813rem;\n    width: 2.813rem;\n    background-color: white;\n    margin: 0 0.688rem 0 1rem;\n  "], ["\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 2.813rem;\n    width: 2.813rem;\n    background-color: white;\n    margin: 0 0.688rem 0 1rem;\n  "])));
  var checkContainer = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0 0.875rem 0 0;\n  "], ["\n    margin: 0 0.875rem 0 0;\n  "])));
  return jsx(View, {
    "data-testid": title,
    onClick: callback,
    css: cardContent
  }, jsx(View, {
    css: content
  }, jsx(View, {
    css: imageContainer
  }, icon), jsx(View, null, jsx(Text, {
    css: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            font-weight: 600;\n            line-height: 20px;\n            min-width:13.75rem;\n            font-size:1rem;\n          "], ["\n            font-weight: 600;\n            line-height: 20px;\n            min-width:13.75rem;\n            font-size:1rem;\n          "]))),
    variant: 'h6'
  }, title), jsx(Text, {
    css: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            font-size:0.85rem;\n            letter-spacing:0; \n            max-width:10.75rem;\n            line-height:1.2rem;"], ["\n            font-size:0.85rem;\n            letter-spacing:0; \n            max-width:10.75rem;\n            line-height:1.2rem;"]))),
    variant: 'paragraph'
  }, description)), jsx(View, {
    css: checkContainer
  }, jsx("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    fill: 'none'
  }, jsx("path", {
    d: 'M5 2L11 8L5 14',
    stroke: '#021215',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;